<template>
  <BaseModalSmall testId="email-domain-info">
    <Flex direction="column">
      <BaseHeading>{{ $t('email_domain.title') }}</BaseHeading>
      <BaseText inline>
        {{ $t('email_domain.email_domain_popup_info') }}
      </BaseText>
      <BaseText
        inline
        :href="helpCenterArticleUrl($t('email_domain.help_url'))"
      >
        {{ $t('email_domain.more_info') }}
      </BaseText>
    </Flex>
  </BaseModalSmall>
</template>

<script
  lang="ts"
  setup
>
import { helpCenterArticleUrl } from '@/helpers/help-center';
</script>
